import { createContext } from 'react';

export type WorkflowCtx = {
  showWorkflowActivate: boolean;
  showWorkflowDeactivate: boolean;
  showWorkflowErrorAlert: boolean;
  showWorkflowSave: boolean;
  showWorkflowCreate: boolean;
  workflowDescription: string;
  workflowError: string;
  workflowName: string;
};

const WorkflowDialogueContext = createContext<WorkflowCtx>({
  showWorkflowActivate: false,
  showWorkflowDeactivate: false,
  showWorkflowErrorAlert: false,
  showWorkflowSave: false,
  showWorkflowCreate: false,
  workflowDescription: '',
  workflowError: '',
  workflowName: '',
});

export default WorkflowDialogueContext;
